interface IRR {
  id: number,
  title: string,
  author: string,
  year: number,
  filename: string,
  imgSrc?: string,
  show: boolean,
}

export const RRs: IRR[] = [
  {
    id: 6,
    title: "Anomalous Trajectory Detection in Vehicular Social Networks with Unsupervised Dynamic Network Representation Learning",
    author: "Shen, Guojiang and He, Yuwei and Kong, Xiangjie and Ji, Zhanhao and Wang, Lei and Zhou, Junjie and Hu, Linglong",
    year: 2025,
    filename: "Anomalous_Trajectory_Detection_in_Vehicular_Social_Networks_with_Unsupervised_Dynamic_Network_Representation_Learning.pdf",
    imgSrc: "/images/research/2025Anomalous.png",
    show: true,
  },
  {
    id: 8,
    title: "Broad information diffusion modelling for sharing link click prediction using knowledge graphs",
    author: "Kong, Xiangjie and Shu, Can and Wang, Lingyun and Zhou, Hanlin and Zhu, Linan and Li, Jianxin",
    year: 2025,
    filename: "Broad Information Diffusion Modeling for Sharing Link Click Prediction Using Knowledge Graphs.pdf",
    imgSrc: "/images/research/2025K-BID.png",
    show: true,
  },
  {
    id: 1,
    title: "Multimodal sentiment analysis with unimodal label generation and modality decomposition",
    author: "Zhu, Linan and Zhao, Hongyan and Zhu, Zhechao and Zhang, Chenwei and Kong, Xiangjie",
    year: 2025,
    filename: "Multimodal sentiment analysis with unimodal label generation and modality decomposition.pdf",
    show: true,
  },
  {
    id: 12,
    title: "Action Detail Matters: Refining Video Recognition with Local Action Queries",
    author: "Wang, Mengmeng and Huang, Zeyi and Kong, Xiangjie and Shen, Guojiang and Dai, Guang and Wang, Jingdong and Liu, Yong",
    year: 2025,
    filename: "Wang_Action_Detail_Matters_Refining_Video_Recognition_with_Local_Action_Queries_CVPR_2025_paper.pdf",
    show: true,
  },
  {
    id: 11,
    title: "TrackAny3D: Transferring Pretrained 3D Models for Category-unified 3D Point Cloud Tracking",
    author: "Mengmeng Wang, Haonan Wang, Yulong Li, Xiangjie Kong, Jiaxin Du, Feng Xia, and Guojiang Shen",
    year: 2025,
    filename: "TrackAny3D_Transferring Pretrained 3D Models for Category-unified 3D Point Cloud Tracking.pdf",
    show: true,
  },
  {
    id: 7,
    title: "LLM-TPF: Multiscale Temporal Periodicity-Semantic Fusion LLMs for TimeSeries Forecasting",
    author: "Qihong Pan and Haofei Tan and Guojiang Shen and Xiangjie Kong and Mengmeng Wang and Chenyang Xu",
    year: 2025,
    filename: "LLM-TPF_Multiscale Temporal Periodicity-Semantic Fusion LLMs for TimeSeries Forecasting.pdf",
    show: true,
  },
  {
    id: 10,
    title: "Tackling Sparse Facts for Temporal Knowledge Graph Completion",
    author: "Zhang, Yuchao and Kong, Xiangjie and Ye, Kailun and Shen, Guojiang and Zheng, Shangfei",
    year: 2025,
    filename: "Tackling Sparse Facts for Temporal Knowledge Graph Completion.pdf",
    show: true,
  },
  {
    id: 9,
    title: "Pattern-Matching Dynamic Memory Network for Dual-Mode Traffic Prediction",
    author: "Weng, Wenchao and Wu, Mei and Jiang, Hanyu and Kong, Wanzeng and Kong, Xiangjie and Xia, Feng",
    year: 2025,
    filename: "Pattern-Matching Dynamic Memory Network for Dual-Mode Traffic Prediction.pdf",
    show: true,
  },
  {
    id: 5,
    title: "Let's group: A Plug-and-Play SubGraph Learning method for Memory-Efficient Spatio-Temporal Graph Modeling",
    author: "Wenchao Weng and Hanyu Jiang and Mei Wu and Xiao Han and Haidong Gao and Guojiang Shen and Xiangjie Kong",
    year: 2025,
    filename: "Let's group_A Plug-and-Play SubGraph Learning method for Memory-Efficient Spatio-Temporal Graph Modeling.pdf",
    imgSrc: "/images/research/2020TBI2Flow.png",
    show: true,
  },
  {
    id: 4,
    title: "Spatial homogeneity-aware transfer learning for urban flow prediction",
    author: "Liu, Yinghui and Shen, Guojiang and Fu, Yanjie and Feng, Zehui and Zhao, Zhenzhen and Kong, Xiangjie",
    year: 2025,
    filename: "Spatial homogeneity-aware transfer learning for urban flow prediction.pdf",
    imgSrc: "/images/research/2020Emergency.png",
    show: true,
  },
  {
    id: 3,
    title: "Uncertainty-aware traffic accident risk prediction via multi-view hypergraph contrastive learning",
    author: "Zhang, Yimei and Shen, Guojiang and Zhang, Wenyi and Ning, Kaili and Jiang, Renhe and Kong, Xiangjie",
    year: 2025,
    filename: "Uncertainty-Aware Trafic Accident Risk Prediction via Multi-View Hypergraph Contrastive Learning.pdf",
    show: true,
  },
  {
    id: 2,
    title: "Towards Heterogeneous Federated Graph Learning via Structural Entropy and Prototype Aggregation",
    author: "Dai, Zhehao and Shen, Guojiang and Yuan, Haopeng and Zheng, Shangfei and Hu, Yuyue and Du, Jiaxin and Kong, Xiangjie and Xia, Feng",
    year: 2025,
    filename: "Towards Heterogeneous Federated Graph Learning via Structural Entropy and Prototype Aggregation.pdf",
    show: true,
  }
]
